const i18n = require('i18n');

cc.Class({
    extends: cc.Component,

    properties: {
        localizationKey: 'key',
        text: '',
        font: cc.Font,
        radius: 200,
        fontSize: 15,
        color: cc.Color,
        topDir: 1,
        upperCase: true
    },

    start () {
        this.text = this.text.length ? this.text : i18n.t(this.localizationKey);

        this._setText(this.text);
    },

    updateLocKey (key) {
        this.localizationKey = key;
        this.text = i18n.t(this.localizationKey);
        this._setText(this.text);
    },

    _setText (text) {
        this.node.removeAllChildren();
        if (this.upperCase) {
            this.text = text.toUpperCase();
        } else {
            this.text = text;
        }

        this.digits = [];
        const r = this.radius;
        let totalWidth = 0;
        let currentWidth = 0;

        for (let i = 0; i < this.text.length; i++) {
            this._createDigit(this.text[i]);
            const label = this.digits[i].node;

            totalWidth += label.width;
        }
        const totalAngle = this._radToDeg(totalWidth / r);
        let currentAngle =  -totalAngle / 2;

        totalWidth -= this.digits[0].node.width / 2;
        totalWidth -= this.digits[this.text.length - 1].node.width / 2;

        for (let i = 0; i < this.text.length; i++) {
            const label = this.digits[i].node;

            // label.x = currentWidth;
            // currentWidth += label.width;
            label.x = Math.sin(this._degToRad(currentAngle)) * r;
            label.y = this.topDir * Math.cos(this._degToRad(currentAngle)) * r;
            label.angle = -this.topDir * currentAngle;

            if (this.digits[i + 1]) {
                currentWidth += label.width / 2  + this.digits[i + 1].node.width / 2 ;
            }
            currentAngle = totalAngle * currentWidth / totalWidth - totalAngle / 2;

        }
    },

    _degToRad (deg) {
        return deg * Math.PI / 180;
    },

    _radToDeg (rad) {
        return rad * 180 / Math.PI;
    },

    _createDigit (digit) {
        const digitNode = new cc.Node('Char');
        const digitLabel = digitNode.addComponent(cc.Label);

        digitLabel.fontSize = this.fontSize;
        digitLabel.lineHeight = this.fontSize + 10;
        digitLabel.font = this.font;
        digitLabel.string = digit;
        digitLabel.node.color = this.color;

        this.node.addChild(digitNode);
        this.digits.push(digitLabel);
        return digitNode;
    }
});
